import { asset } from '@/lib/assets'
import { SITE_URL } from '@/lib/siteUrl'
import {
  CAMPAIGN_ICON_FEEDBACK,
  CAMPAIGN_ICON_FORUM,
  CAMPAIGN_ICON_MENU_BOOK,
  CAMPAIGN_PAGE_BACKGROUND,
} from '@/components/campaign/sharedAssets'
import type { InterviewPracticeCampaignConfig } from '@/components/campaign/types'

/** Figma: Landing-page-meritlens → Final (2154:269) → Security Engineering (Desktop 11 / iPhone 14 & 15 Pro - 5). */
const IMG_HERO = asset('/assets/images/data-analytics-engineering/hero-security-pipeline.png')
const IMG_OFFER_CARD = asset('/assets/images/data-analytics-engineering/security-offer-card.png')

const OG_IMAGE = `${SITE_URL}/images/backgroundImages.jpg`

export const securityEngineeringCampaignConfig: InterviewPracticeCampaignConfig = {
  path: '/security-engineering',
  analyticsSource: 'security_engineering',
  analytics: {
    pageViewed: 'security_page_viewed',
    ctaClicked: 'security_cta_clicked',
    checkoutStarted: 'security_checkout_started',
  },
  idPrefix: 'sec',

  seo: {
    title: 'Security Engineering Interview Practice',
    description:
      'Catch security flaws before the interview does. Practice pipeline security and threat modeling scenarios with meritlens mock interviews and structured feedback.',
    openGraphTitle: 'Security Engineering Interview Practice | meritlens',
    openGraphDescription:
      'Think like a security engineer and interview like one. Realistic security scenarios based on your resume.',
    twitterDescription:
      'Practice security engineering interview scenarios, patch blind spots, and walk in ready to defend every layer.',
    heroImageForSharing: OG_IMAGE,
    heroImageAlt: 'Security engineering interview practice with meritlens',
  },

  hero: {
    roleBadge: 'Security Engineering',
    titleLine: 'Think Like a Security Engineer.',
    titleAccent: 'Interview Like One.',
    subtitle:
      'Catch security flaws in your answers before the interview catches them. Practice real pipeline security and threat modeling scenarios, patch your blind spots, and walk in confident you can defend every layer.',
    heroImageSrc: IMG_HERO,
    heroImageAlt: 'Security engineering interview practice with meritlens',
  },

  pageBackgroundImage: CAMPAIGN_PAGE_BACKGROUND,

  offer: {
    cardTitle: 'Crack Your Next Technical Round',
    offerPreviewImage: IMG_OFFER_CARD,
    microcopy: "Don't lose a top offer over small mistakes",
    bullets: [
      'Face realistic security scenarios based on your resume and experience',
      'Identify your blind spots with actionable feedback before the real interview',
    ],
  },

  why: {
    intro:
      'Practise applying your knowledge, explaining your approach, and tackling technical questions in an interview-like experience.',
    features: [
      {
        icon: CAMPAIGN_ICON_FORUM,
        titleDesktop: 'Think Through Real-World Scenarios',
        titleMobile: 'Real-world security scenarios',
        description:
          'Practise questions around secure deployments, vulnerabilities, and infrastructure security.',
      },
      {
        icon: CAMPAIGN_ICON_MENU_BOOK,
        titleDesktop: 'Explain the Why Behind Your Decisions',
        titleMobile: 'Explain your security decisions',
        description:
          'Practise communicating your approach to security controls, risks, and trade-offs.',
      },
      {
        icon: CAMPAIGN_ICON_FEEDBACK,
        titleDesktop: 'Know Where to Improve',
        titleMobile: 'Know where to improve',
        description:
          'Use structured feedback to identify strengths and areas that need more preparation.',
      },
    ],
  },
}
